module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABQElEQVR4AeySTU4CQRCFCxEPoQs5mZFgoguNnoDEE7jQjYkEE7ceChdyCH4C36t0d2iYMMwAGwKpR1e/rqpXVZkzO/DvJFC64CNc0dysC+Y1cbu6s2xFFB0T8AXq2oAa0+XkJBAeWuGx3TBrVIGZXQFZk1pqVL65AIRGa4oJRf/kl4G8V+DrJLanXE5ZC74rxwVwBkAWu5C/ERR4I6AHot3DvXNpA5mvOgqIMDoYubPd30tB2CM1sukzgYKEnalMgBEvK1T8LIj9ocb1Mh8FOoH8D2fpwSoeCPoA0X7hbrgMgexOfy7AwzeXGTA60FeRdSG+COQ9Af+ceX9WLqdsAt+X4wJyIM45J0A2VHAVkBSnn1HrgrtbEtAtPPhoutdAhxpqNKVmAmIJ6AMfu8apVatMwppAetmTcxIoXeTBV7QAAAD//4ohXz0AAAAGSURBVAMA2yJpMZkfF6wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/toggle_on_red.png
// module id = IwjA
// module chunks = 4